class ProductViewService {

    constructor() {
        this.product = {};
        this.variant = {};
        this.price = {};
        this.frameSizes = {};
    }

    setProduct(product) {
        this.product = product;

        this.updateProductInfoHelper();
    }

    setVariant(variant) {
        this.variant = variant;

        this.updateProductInfoHelper();
    }

    setPrice(price) {
        this.price = price;

        this.updateProductInfoHelper();
    }

    updateProductInfoHelper() {
        if (typeof (productInfoHelper) === 'undefined') {
            return;
        }

        productInfoHelper.setName(this.product.name);
        productInfoHelper.setVariantName(this.variant && this.variant.name ? this.variant.name : '');
        productInfoHelper.setPrice(Scripts.numberFormat(this.price.price_gros, 2, ',', ' ').toString().replace(/\s/g, '').replace(',', '.'));
        productInfoHelper.setPriceNet(Scripts.numberFormat(this.price.price_net, 2, ',', ' ').toString().replace(/\s/g, '').replace(',', '.'));
    }

    setFrameSizes(frameSizes) {
        this.frameSizes = frameSizes;
    }

    getFrameSizes() {
        let sizes = [];
        this.frameSizes.forEach(frameSize => {
            sizes.push(parseInt(frameSize.name));
        })
        return sizes.sort();
    }
}

export default ProductViewService;
